import styled from '@mui/system/styled';
import Checkbox from '@mui/material/Checkbox';

export const StyledCheckbox = styled(Checkbox)({
  minWidth: 26,
  padding: '0 8px 0 0',
});
